export default __webpack_public_path__ + "src/static/img/png/v2/page-payment-gateway/card4.png";